"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageAttemptHeadersOut = void 0;
class MessageAttemptHeadersOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return MessageAttemptHeadersOut.attributeTypeMap;
    }
}
exports.MessageAttemptHeadersOut = MessageAttemptHeadersOut;
MessageAttemptHeadersOut.discriminator = undefined;
MessageAttemptHeadersOut.attributeTypeMap = [
    {
        "name": "responseHeaders",
        "baseName": "responseHeaders",
        "type": "Array<Array<string>>",
        "format": ""
    },
    {
        "name": "sensitive",
        "baseName": "sensitive",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "sentHeaders",
        "baseName": "sentHeaders",
        "type": "{ [key: string]: string; }",
        "format": ""
    }
];
//# sourceMappingURL=MessageAttemptHeadersOut.js.map